import React, { useEffect, useRef } from 'react';
import ReactSignatureCanvas from 'react-signature-canvas';
import InputLabel from '@material-ui/core/InputLabel';
import { useTranslation } from 'react-i18next';
import { FormHelperText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import isEmpty from 'lodash/isEmpty';
import { SIGNATURE, MASK } from 'utils/constants/css';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  errorVisible: {
    opacity: 1,
    color: theme.palette.error.main,
  },
  errorHidden: {
    opacity: MASK.OPACITY_LOW,
  },
  mask: {
    position: 'absolute',
    opacity: MASK.OPACITY_LOW,
    left: 0,
    height: 'inherit',
    width: 'inherit',
    background: theme.palette.text.disabled,
  },
  sigImage: {
    width: SIGNATURE.WIDTH,
    height: SIGNATURE.HEIGHT,
    backgroundColor: 'white',
  },
  sigContainer: {
    margin: '0 auto',
    position: 'relative',
  },
  sigPad: {
    width: SIGNATURE.WIDTH,
    height: SIGNATURE.HEIGHT,
    border: `1px solid ${theme.palette.secondary.main}`,
  },
}));

const Signature = ({
  onChange,
  label,
  required,
  error,
  displayError = true,
  base64url,
  disabled = false,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const sigRef = useRef();

  // const clear = () => {
  //   sigRef.current.clear();
  //   onChange(null);
  // };

  const handleSignatureEnd = () => {
    onChange(sigRef.current.toDataURL('image/jpeg'));
  };
  useEffect(() => {
    // automaticlly clear the signature if there is no base64url. This is useful for triggring clear from outside this component
    if (!base64url) {
      sigRef.current.clear();
    }
  }, [base64url]);
  return (
    <>
      {label && (
        <InputLabel
          shrink
          disableAnimation
          required={required}
          htmlFor="component-error"
          variant="standard"
          focused={false}
        >
          {t(label)}
        </InputLabel>
      )}
      <>
        {disabled && <div className={classes.mask}></div>}
        {base64url && base64url.includes('/media') ? (
          // <div className={cn(classesNames)}>
          <img
            className={classes.sigImage}
            src={base64url}
            alt={'signaturePad'}
          />
        ) : (
          // </div>

          <ReactSignatureCanvas
            penColor="black"
            backgroundColor="white" // this has to be white because JPEGs don't support transparency, so that means if we dont set background as white, it becomes "black". PNGs support transparency, hence the difference.
            canvasProps={{
              width: '300',
              height: '300',
              className: classes.sigPad,
            }}
            ref={sigRef}
            onEnd={handleSignatureEnd}
          />
        )}
      </>

      {displayError && !isEmpty(error) && (
        <FormHelperText
          className={error ? classes.errorVisible : classes.errorHidden}
          id="component-error-text"
        >
          {t(error)}
        </FormHelperText>
      )}
    </>
  );
};

Signature.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  displayError: PropTypes.bool,
  base64url: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Signature;
